export enum Roles {
  guest = 'guest',
  user = 'user',
  admin = 'admin',
}
